;(function() {
/* @ngInject */
function VirtualneSidloObjednaneController(CompletedOrderService, $window, $filter) {
    let vm = this;
    let server = CompletedOrderService;

    vm.payment = "movement";
    vm.showMovement = false;
    vm.downloadLabel = $filter("translate")('payments.documents.general');

    server.getCompletedOrderData().then(onPaymentInfoLoad);

    function onPaymentInfoLoad(payment) {
        if(payment) {
            vm.orderId = payment.orderId;
            vm.price = payment.price;
            vm.paymentData = payment;
        } else {
            $window.location = "krok1";
        }
    }
}

angular.module("firmaren")
    .controller("VirtualneSidloObjednaneController", VirtualneSidloObjednaneController);
}());
